import boopSfx from '../mp3/card.mp3';
import leaveSfx from '../mp3/leave.mp3';
import whatsappSfx from '../mp3/whatsapp.mp3';

class SoundManager {
  constructor() {
    this.activeSounds = {};
    this.lastPlayedMessageIds = {
      new: null,
      internal_message: null,
    };
    this.lastPlayedAtByType = {};
    this.cooldownMsByType = {
      new: 900,
      internal_message: 900,
      leave: 400,
    };
  }

  async playSound(soundType, messageUid = null) {
    const playFn = this.createPlayFn(soundType, messageUid);
    if (!playFn) {
      return;
    }

    try {
      await this.playWithCooldown(soundType, playFn);
    } catch (error) {
      console.error(`Erro ao reproduzir som '${soundType}':`, error);
    }
  }

  createPlayFn(soundType, messageUid) {
    if (soundType === 'new') {
      if (messageUid && messageUid === this.lastPlayedMessageIds.new) {
        return null;
      }

      return async () => {
        const audio = new Audio(boopSfx);
        await audio.play();
        if (messageUid) {
          this.lastPlayedMessageIds.new = messageUid;
        }
      };
    }

    if (soundType === 'leave') {
      return async () => {
        const audio = new Audio(leaveSfx);
        await audio.play();
      };
    }

    if (soundType === 'internal_message') {
      if (messageUid && messageUid === this.lastPlayedMessageIds.internal_message) {
        return null;
      }

      return async () => {
        const audio = new Audio(whatsappSfx);
        await audio.play();
        if (messageUid) {
          this.lastPlayedMessageIds.internal_message = messageUid;
        }
      };
    }

    return null;
  }

  async playWithCooldown(soundType, playFn) {
    const now = Date.now();
    const cooldownMs = this.cooldownMsByType[soundType] || 0;
    const lastPlayedAt = this.lastPlayedAtByType[soundType] || 0;
    const elapsed = now - lastPlayedAt;

    if (cooldownMs > 0 && elapsed < cooldownMs) {
      return;
    }

    this.lastPlayedAtByType[soundType] = now;
    await playFn();
  }

  async startRinging(type = 'incoming') {
    try {
      this.stopRinging();

      // Use premium royalty-free SFX for a better user experience
      const soundUrl =
        type === 'outgoing'
          ? '/mixkit-waiting-ringtone-1354.wav' // Custom dial tone requested by user
          : '/bling_bang_bang_born.mp3'; // Pleasant ringtone

      const audio = new Audio(soundUrl);
      audio.loop = true;
      await audio.play();
      this.activeSounds.ringtone = audio;
    } catch (error) {
      console.error('Erro ao iniciar toque de chamada:', error);
    }
  }

  stopRinging() {
    if (this.activeSounds.ringtone) {
      this.activeSounds.ringtone.pause();
      this.activeSounds.ringtone.currentTime = 0;
      delete this.activeSounds.ringtone;
    }
  }
}

export const soundManager = new SoundManager();
